import React, { useState, useEffect } from "react";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { notificationActions } from "../actions/notificationActions";
import { cartActions } from "../actions/cartActions";
import { makeRequest } from "../apis/makeRequest";
import { getProduct, getValidarCarga } from "../apis/backendRequests";
import { Grid, Button, Box, useMediaQuery, useTheme } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ProductCard from "../components/ProductCard";
import TableUnit from "../components/TableUnit";
import PopUp from "../components/PopUp";
import Breadcrumb from "../components/Breadcrumb";

const styles = {

  breadCrumb: {
    fontSize: "14px",
    marginBottom: "10px",
  },
  link: {
    fontSize: "14px",
    cursor: "pointer",
  },
  boxTop: {
    display: "flex",
    flexDirection: "column",
    justifyCOntent: "center",
    marginBottom: "30px",
    marginTop: "10px",
    gap: "10px"
  },
  buttonVolver: {
    width: "18%",
    fontSize: "12px",
    color: "black",
    borderColor: "grey",
  },
  buttonVolverMobile: {
    width: "90%",
    fontSize: "12px",
    color: "black",
    borderColor: "grey",
  },
};

export default function ProductDetails() {
  const { productId } = useParams();
  const { items } = useSelector((state) => state.cart);
  const { dynamicsId } = useSelector((state) => state.account);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const theme = useTheme()
  const mobile = useMediaQuery(theme.breakpoints.down("md"))

  const [product, setProduct] = useState({});
  const [unit, setUnit] = useState();
  const [showMsg, setShowMsg] = useState(false);
  const [msg, setMsg] = useState("");

  useEffect(() => {
    localStorage.setItem("cartItems", JSON.stringify(items));
    localStorage.setItem("orderItems", []);
  }, [items]);

  useEffect(() => {
    if (!productId) return;

    makeRequest(
      () => getProduct(productId, dynamicsId),
      (res) => setProduct(res.data),
      null,
      { checkEmptyResults: false }
    );
  }, [productId, dynamicsId]);

  const checkCarga = () => {
    const value = unit;
    const validate = value.toString().charAt(0);
    if (validate === "0" && value.length > 1) {
      setMsg("Valor ingresado de manera erronea, por favor intente de nuevo");
      setShowMsg(true);
      return;
    }
    makeRequest(
      () => getValidarCarga(productId, unit),
      (res) => {
        if (res.data.leyenda === "ok") {
          submit();
        } else {
          setMsg(res.data.leyenda);
          return setShowMsg(true);
        }
      }
    );
  };

  const submit = () => {
    const existItem = items.find((obj) => obj.productId === productId);
    if (existItem) {
      const unitCheck = unit;
      const i = items.indexOf(existItem);
      if (!location.state) {
        setShowMsg(true);
        return setMsg(
          "Producto ya añadido, si desea editar o añadir cantidad, dirijase al sector del carrito"
        );
      }
      makeRequest(
        () => getValidarCarga(productId, unitCheck),
        (res) => {
          if (res.data.leyenda === "ok") {
            dispatch(
              cartActions.editItem(i, {
                ...product,
                ["quantity"]: unitCheck,
              })
            );
            dispatch(
              notificationActions.showSuccess({
                message: "Se han editado los productos seleccionados",
              })
            );
            return location.state !== "" ? navigate("/cart") : navigate("/");
          } else {
            setShowMsg(true);
            setMsg(res.data.leyenda);
            return;
          }
        }
      );
    } else {
      dispatch(
        cartActions.addItem({
          ...product,
          quantity: unit,
        })
      );
      dispatch(
        notificationActions.showSuccess({
          message: "Se han agregado los productos seleccionados",
        })
      );
      return navigate("/");
    }
  };

  return (
    <>
      <Box marginLeft={"5%"} style={styles.boxTop}>
        <Breadcrumb
          prodCategoria={product.categoriaDescription}
          prodRubro={product.rubroDescription}
          prodSubRubro={product.subRubroDescription}
        />
        {location.state && (
          <Button
            size="small"
            style={mobile ? styles.buttonVolverMobile : styles.buttonVolver}
            variant="outlined"
            startIcon={<ChevronLeftIcon />}
            onClick={() => {
              navigate("/cart");
            }}
          >
            Volver al carrito
          </Button>
        )}
      </Box>
      <Grid container style={mobile ? { display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" } : {}}>
        {!mobile && <Grid item xs={1.5} />}
        <Grid marginTop={mobile ? 0 : 3} style={{ padding: 0 }} item sm={12} md={6}>
          {typeof product.productId !== "undefined" && (
            <ProductCard product={product} />
          )}
        </Grid>
        <Grid marginTop={3} style={{ padding: 0 }} item sm={12} md={4}>
          <TableUnit
            product={product}
            setterUnit={setUnit}
            isEdit={location.state}
            submit={checkCarga}
          />
          <Grid item sm={12} md={2} />
        </Grid>
        <PopUp open={showMsg} setClose={setShowMsg} msg={msg} />
      </Grid>
    </>
  );
}
